module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Sneakers-23165f19e4a41106cefb8447b7b93302.svg";